import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { inject, observer } from 'mobx-react';
import NumberValidator from 'utils/numberValidator';
import { authorize } from 'utils/auth';
import { NOT_ON_FILE, NO_IMAGE_URL } from 'config/constants';
import { FormattedMessage, getMessagesForLocale } from 'ui/i18n';
import { getIndexForItem } from 'state/helpers';

import './ColorItem.scss';

@inject('AppState', 'CartState')
@observer
export default class ColorItem extends Component {
	static propTypes = {
		AppState: PropTypes.object.isRequired,
		CartState: PropTypes.object.isRequired,
		item: PropTypes.object.isRequired,
		isPack: PropTypes.bool.isRequired,
		isPreview: PropTypes.bool,
		totalQuantity: PropTypes.number.isRequired,
		handleOnChange: PropTypes.func.isRequired,
		inEditMode: PropTypes.bool,
		cartItem: PropTypes.object.isRequired,
		itemNumber: PropTypes.string,
		isSoldOut: PropTypes.bool.isRequired,
	};

	static defaultProps = {
		inEditMode: false,
		isPreview: false,
		itemNumber: '',
	};

	componentDidMount() {
		if (this.props.inEditMode) {
			//if is in edit mode, populate field if were ordered already
			const index = getIndexForItem(
				this.props.CartState.cartItems,
				this.props.cartItem,
				this.props.isPack
			);

			if (index >= 0) {
				const item = this.props.CartState.cartItems[index];

				const configuration = item.configurations.find(
					conf =>
						conf.id === this.props.item.id &&
						conf.number === this.props.item.item_number
				);

				if (configuration) {
					this.quantityInput.value = configuration.quantity_ordered;
					this.props.handleOnChange(
						true,
						this.props.item,
						configuration.quantity_ordered
					);
				}
			}
		}
	}

	onChange(e) {
		let { value } = e.target;
		let isValid = false;
		const numberValidator = new NumberValidator();

		if (numberValidator.hasCharacters(value)) {
			value = parseInt(value.replace(/\D/g, ''), 10); // eliminate anything but digits
		} else {
			value = parseInt(value, 10);
		}

		isValid = !!value;
		e.target.value = isValid ? value : '';

		this.props.handleOnChange(isValid, this.props.item, value);
	}

	hasImage(url) {
		const NO_IMAGE = 'no_image_large';
		if (url) {
			return !url.includes(NO_IMAGE);
		}

		return false;
	}

	render() {
		const { item, totalQuantity } = this.props;
		const { locale } = this.props.AppState;
		const imageUrl = this.hasImage(item.image_url)
			? item.image_url
			: NO_IMAGE_URL;

		return (
			<div className="ColorItem">
				<img src={imageUrl} alt={item.item_number} />

				<div className="ColorItem-content">
					<p id="ColorItemNumber">
						{item.item_number}
					</p>
					<p id="ColorName" className="color-name">
						{item.color_name === NOT_ON_FILE
							? getMessagesForLocale(locale)['chooseColor.notOnFile']
							: item.color_name}
					</p>
					<label className="item-quantity">
						<FormattedMessage id="chooseColor.qtyText" />
						<input
							className="item-quantity-text"
							type="text"
							ref={input => {
								this.quantityInput = input;
							}}
							disabled={
								(!totalQuantity && this.props.isPack) ||
								this.props.AppState.isOnHoldOrTerminated ||
								this.props.isPreview ||
								!authorize(['AddToCart'], true, false)
							}
							onChange={this.onChange.bind(this)}
						/>
					</label>
				</div>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/ui/components/ColorItem/index.js